<ul class="breadcrumb">
    <li><a [routerLink]="['/home']"><span class="color-soft-grey-axial">ESTÁS EN </span>Inicio</a></li>
    <li><i class="pi pi-angle-right"></i></li>
    <li><a [routerLink]="['/configuration/entities']">Configuración</a></li>
    <li><i class="pi pi-angle-right"></i></li>
    <li><a [routerLink]="['/configuration/provinces']">Provincias</a></li>
    <!--<li *ngIf="view"><a [routerLink]="['/configuration/provinces']">{{view.getEntityBaseName(true)}}</a></li>-->
</ul>
<p-confirmDialog [style]="{width: '50vw'}" [baseZIndex]="10000"></p-confirmDialog>

<!--<app-view #view [code]="'provinces.list'" [model]="provincesFilters" (onEvent)="onEvent($event)"></app-view>-->

<p-card>
    <ng-template pTemplate="header">
        <div class="p-card-title">
            Filtros
            <div class="p-card-title-actions">
                <a (click)="search()"><i class="fas fa-search"></i>&nbsp;Buscar </a>
            </div>
        </div>
    </ng-template>
    <div class="p-grid">
        <div class="p-col p-field">
            <label for="name">Nombre</label>
            <input id="name" type="text" pInputText [(ngModel)]="provincesFilters.name" />
        </div>
        <div class="p-col-4 p-field">
            <label for="country_id">País</label>
            <p-dropdown [options]="countries" optionLabel="name" optionValue="id" [(ngModel)]="provincesFilters.country_id" placeholder="Selecciona país"></p-dropdown>
        </div>
    </div>
    <!--div class="p-grid">
          <div class="p-col p-ai-right">
              <p-button label="Limpiar filtros" (click)="clearFilters()" styleClass="p-button-secondary"></p-button>
              <p-button label="Buscar" (click)="search()" class="p-ml-2"></p-button>
          </div>
      </div-->
</p-card>
<br>
<p-card styleClass="p-card-content-fit">
    <ng-template pTemplate="header">
        <div class="p-card-title">
            Provincias
            <div class="p-card-title-actions">
                <a (click)="edit({ id: 0 })">
                    <fa-icon [icon]="['fas', 'plus-circle']"></fa-icon> Nueva provincia
                </a>
            </div>
        </div>
    </ng-template>
    <p-table #grid [value]="provinces" [lazy]="true" (onLazyLoad)="loadData($event)" [loading]="loading"
        [paginator]="true" [rows]="10" [totalRecords]="totalRecords" [showCurrentPageReport]="true"
        currentPageReportTemplate="Mostrando de {first} a {last} de un total de {totalRecords} entradas"
        [rowsPerPageOptions]="[5,10,25,50]"  paginatorDropdownAppendTo="body">
        <ng-template pTemplate="header">
            <tr>
                <th pSortableColumn="id" width="100">ID</th>
                <th pSortableColumn="name">Nombre</th>
                <th pSortableColumn="country.name">País</th>
                <th width="100"></th>
            </tr>
        </ng-template>
        <ng-template pTemplate="body" let-province>
            <tr (dblclick)="edit(province)">
                <td>{{province.id}}</td>
                <td>{{province.name}}</td>
                <td>{{province.country.name}}</td>
                <td class="grid-actions">
                    <a (click)="edit(province)">
                        <fa-icon [icon]="['far', 'edit']"></fa-icon>
                    </a>
                    <a (click)="delete(province)" class="color-danger">
                        <fa-icon [icon]="['far', 'trash-alt']"></fa-icon>
                    </a>
                </td>
            </tr>
        </ng-template>
    </p-table>
</p-card>
